import React, { useState, useRef } from "react";
import searchIconGrey from "../icons/searchIconGrey.png";
import searchIconBlack from "../icons/searchIconBlack.png";
import { usePopper } from "react-popper";

const SearchButton = ({ setSelected, setShowMenu, setShowSearch }) => {
  const buttonRef = useRef(null);
  const popperRef = useRef(null);
  const [arrowRef, setArrowRef] = useState(null);
  const [showPopper, setShowPopper] = useState(false);
  const { styles, attributes } = usePopper(
    buttonRef.current,
    popperRef.current,
    {
      placement: "top",
      modifiers: [
        {
          name: "arrow",
          options: {
            element: arrowRef,
          },
        },
        {
          name: "offset",
          options: {
            offset: [-100, 10],
          },
        },
      ],
    }
  );

  const handleSearch = () => {
    setShowSearch(true);
    setShowMenu(false);
    setSelected(null);
  };

  const handleImgMouseOver = (event) => {
    event.currentTarget.src = searchIconBlack;
  };

  const handleImgMouseOut = (event) => {
    event.currentTarget.src = searchIconGrey;
  };

  const windowSizeLarge = () => {
    return window.innerWidth >= "600";
  };

  return (
    <>
      <button
        className="search-btn"
        aria-describedby="tooltip"
        onClick={handleSearch}
        ref={buttonRef}
        onMouseOver={() => setShowPopper(true)}
        onMouseOut={() => setShowPopper(false)}
      >
        <img
          src={searchIconGrey}
          alt="search-icon"
          className="search-icon"
          onMouseOver={handleImgMouseOver}
          onMouseOut={handleImgMouseOut}
        />
      </button>
      {showPopper && windowSizeLarge() ? (
        <div
          id="tooltip"
          role="tooltip"
          ref={popperRef}
          style={styles.popper}
          {...attributes.popper}
        >
          <div
            id="arrow"
            data-popper-arrow
            ref={setArrowRef}
            style={styles.arrow}
          />
          <p id="tooltip-text">Click here to search the map!</p>
        </div>
      ) : null}
    </>
  );
};

export default SearchButton;
